import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Api } from "src/core/services/api.services";
import BcLoading from "src/shared/components/Bc-Loading/Bc-Loading";
import SwitchFields from "src/shared/components/Bc-SwitchFields/Bc-SwitchFields";
import { FormBase } from "src/shared/interface/form-base";
import { FormDynamic } from "src/shared/interface/form-dynamic";
import { DominantColor, Label } from "src/shared/interface/rekognition";
import LayoutMain from "src/shared/layouts/LayoutMain/LayoutMain";
import { BCButton, ContainerReko } from "src/shared/styled/global.styled";

const FormPrimary: FormDynamic = {
  id: "master",
  name: "Formulario Rekognition",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "Agrega la foto a analizar",
      item: "file",
      type: "file",
      isRequired: true,
      placeholder: "Agregar archivo",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};

const Rekognition = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjError, setMsjError] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataPhoto, setDataPhoto] = useState<any>(null);
  const [form, setForm] = useState<FormDynamic>();

  useEffect(() => {
    setForm(FormPrimary);
  }, []);

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const onSubmit = handleSubmit((data: any) => {
    console.log("datos del formulaio --->", data);
    handleFileSelect(data);
    setLoading(true);
    Api.sendPhoto(data.file[0])
      .then((r: any) => {
        setSuccess(true);
        setDataPhoto(r);
        resetField("file");
        setSelectedFile(null);
        setLoading(false);
      })
      .catch((error) => {
        console.log("entro al error", error);
        initState(error);
      });
    });

  const initState = (error: any) => {
    setSuccess(false);
    setError(true);
    setMsjError(error.response.data.message);
    resetField("file");
    setSelectedFile(null);
    setLoading(false);
  };

  const handleFileSelect = (data: any) => {
    setSelectedFile(data.file[0]);
    console.log(selectedFile);
  };

  return (
    <LayoutMain idPage="Rekognition" titlePage={true}>
      <form onSubmit={onSubmit} className="bc-container">
        {form?.fields &&
          form.fields.map((field: FormBase) => (
            <SwitchFields
              key={`master${field.item}`}
              field={field}
              register={register}
              unregister={unregister}
              setValue={setValue}
              isRequired={field.isRequired}
              getValues={getValues}
              watch={watch}
              resetField={resetField}
              multiFile={true}
            />
          ))}
        <BCButton
          type="submit"
          className="bc-button-primary bc-button-small"
          disabled={!isValid || loading}
        >
          Enviar
        </BCButton>
      </form>
      {loading && <BcLoading messages={"Analizando la Imagen..."} />}
      {success && !loading && (
        <ContainerReko className="bc-container">
          <div className="img-cont">
            <img src={dataPhoto?.photoUrl} alt="imagen" />
            {dataPhoto?.data?.detectedText && (
              <p className="img-text">
                {" "}
                <strong>Textos en la imagen</strong>
                {JSON.stringify(dataPhoto?.data?.detectedText)}
              </p>
            )}
          </div>
          <div className="data-cont">
            <h3>Tipos de etiquetas</h3>
            {dataPhoto?.data?.responseLabels.Labels.map((label: Label) => (
              <div key={label.Name} className="label-cont">
                <p>
                  <strong>{label.Name}</strong>
                </p>
                <p>{label.Confidence.toFixed(2)}%</p>
              </div>
            ))}
            <br />
            <h3>Propiedades de la imagen</h3>
            <br />
            <h4>Propiedades de la imagen completa</h4>
            <h5>Calidad de la imagen</h5>
            <div className="img-qua">
              <p>
                <strong>Brillo:</strong>
              </p>
              <p>
                {dataPhoto?.data?.responseLabels?.ImageProperties?.Quality.Brightness.toFixed(
                  2
                )}
                %
              </p>
            </div>
            <div className="img-qua">
              <p>
                <strong>Sombra:</strong>
              </p>
              <p>
                {dataPhoto?.data?.responseLabels?.ImageProperties?.Quality.Sharpness.toFixed(
                  2
                )}
                %
              </p>
            </div>
            <div className="img-qua">
              <p>
                <strong>Contraste:</strong>
              </p>
              <p>
                {dataPhoto?.data?.responseLabels?.ImageProperties?.Quality.Contrast.toFixed(
                  2
                )}
                %
              </p>
            </div>
            <h5>Colores dominantes</h5>

            {dataPhoto?.data?.responseLabels?.ImageProperties?.DominantColors.map(
              (color: DominantColor, index: number) => (
                <div key={color.HexCode} className="img-qua">
                  <div
                    className="circle-color"
                    style={{ backgroundColor: `${color.HexCode}` }}
                  ></div>
                  <p>
                    {color.HexCode}, RGB({color.Red},{color.Green},{color.Blue}
                    ), {color.CSSColor}
                  </p>
                  <p>{color.PixelPercent.toFixed(2)}%</p>
                </div>
              )
            )}
            <br />
            {dataPhoto?.data?.responseLabels.ImageProperties?.Foreground && (
              <>
                <h4>Propiedades del primer plano</h4>
                <h5>Calidad de la imagen</h5>
                <div className="img-qua">
                  <p>
                    <strong>Brillo:</strong>
                  </p>
                  <p>
                    {dataPhoto?.data?.responseLabels.ImageProperties?.Foreground?.Quality?.Brightness.toFixed(
                      2
                    )}
                    %
                  </p>
                </div>
                <div className="img-qua">
                  <p>
                    <strong>Sombra:</strong>
                  </p>
                  <p>
                    {dataPhoto?.data?.responseLabels.ImageProperties?.Foreground?.Quality.Sharpness.toFixed(
                      2
                    )}
                    %
                  </p>
                </div>
                <h5>Colores dominantes</h5>

                {dataPhoto?.data?.responseLabels?.ImageProperties?.Foreground?.DominantColors.map(
                  (color: DominantColor, index: number) => (
                    <div key={color.HexCode} className="img-qua">
                      <div
                        className="circle-color"
                        style={{ backgroundColor: `${color.HexCode}` }}
                      ></div>
                      <p>
                        {color.HexCode}, RGB({color.Red},{color.Green},
                        {color.Blue}
                        ), {color.CSSColor}
                      </p>
                      <p>{color.PixelPercent.toFixed(2)}%</p>
                    </div>
                  )
                )}

                <br />
              </>
            )}

            {dataPhoto?.data?.responseLabels.ImageProperties?.Background && (
              <>
                <h4>Propiedades del Fondo</h4>
                <h5>Calidad de la imagen</h5>
                <div className="img-qua">
                  <p>
                    <strong>Brillo:</strong>
                  </p>
                  <p>
                    {dataPhoto?.data?.responseLabels.ImageProperties?.Background?.Quality?.Brightness.toFixed(
                      2
                    )}
                    %
                  </p>
                </div>
                <div className="img-qua">
                  <p>
                    <strong>Sombra:</strong>
                  </p>
                  <p>
                    {dataPhoto?.data?.responseLabels.ImageProperties?.Background?.Quality.Sharpness.toFixed(
                      2
                    )}
                    %
                  </p>
                </div>
                <h5>Colores dominantes</h5>

                {dataPhoto?.data?.responseLabels?.ImageProperties?.Background?.DominantColors.map(
                  (color: any, index: number) => (
                    <div key={color.HexCode} className="img-qua">
                      <div
                        className="circle-color"
                        style={{ backgroundColor: `${color.HexCode}` }}
                      ></div>
                      <p>
                        {color.HexCode}, RGB({color.Red},{color.Green},
                        {color.Blue}
                        ), {color.CSSColor}
                      </p>
                      <p>{color.PixelPercent.toFixed(2)}%</p>
                    </div>
                  )
                )}
              </>
            )}
          </div>
        </ContainerReko>
      )}
      {error && !loading && (
        <ContainerReko className="bc-container center-data error-container">
          <h2>No fue posible analizar la imagen</h2>
          <p><strong>Mensaje:</strong> <br /> {msjError}</p>
          <p>Vuelve a intentar la carga de la imagen</p>
        </ContainerReko>
      )}
    </LayoutMain>
  );
};

export default Rekognition;
